module.exports = __webpack_public_path__ + "img/SketchPng10dbb8b1c827af9bf2fcd6acea3fdac927d827e5198975d4388825937100974a.ee4d3da0.png";